import { Component } from '@angular/core';

@Component({
	selector: 'sb-landing-page',
	standalone: true,
	imports: [],
	template: `
		<p>Redirecting to home page...</p>
	`, // Placeholder component - routing handled by HomeNavigationResolver
})
export class HomeComponent {
	// Component never renders - HomeNavigationResolver navigates before activation
}
